<template>
    <div>
        <div class="page-top mb-1 mb-3 align-center clearfix">
            <h1 class="float-left"> Merchant Companies </h1>
            <div class="searching float-right mr-2">
                <input id="customSearch" type="text" class="form-control search" name="" />
            </div>
        </div>
        <table id="companyTable" class="table">
            <thead>
                <tr>
                    <th style="display: none;"></th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Address</th>
                    <th>Action</th>
                </tr>
            </thead>
        </table>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null
            };
        },
        mounted() {
            this.$Progress.start();
            var companyTable = $('#companyTable').DataTable({
                "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                processing: true,
                serverSide: true,
                ajax: {
                    "url": "api/listMerchantCompanies",
                    "headers": window.axios.defaults.headers.common,
                    "dataSrc": "records",
                },
                deferRender: true,
                columns: [
                    {data: 'id', visible: false},
                    {data: 'name'},
                    {data: 'phone'},
                    {data: 'email'},
                    {data: 'address_1'},
                    {data: 'id', sorting: false, render: function(data,type,full){
                        var $url = '/detailMerchantCompany/'+full['id'];
                        return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit"><i class="fas fa-pencil-alt"></i></a>';
                    }}
                ],
                "order": [[ 0, "desc" ]],
                "columnDefs": [{
                    className: "text-center",
                    "targets": [ 4 ]
                }],
                "initComplete": () => {
                    this.$Progress.finish();
                }
            });
             $('#customSearch').on( 'keyup', function () {
                companyTable.search(this.value).draw();
            });
        },
        created() {
            //
        }
    }
</script>
